import React, { useEffect, useState } from "react";
import PayoutModal from "./PayoutModal";
import "./TxnLookup.css";
import { getOrganisation, payoutStatus } from "../../../config/LiveApi";
import { useSelector } from "react-redux";
import { FaFilter } from "react-icons/fa";
import "jspdf-autotable";
import { generatePDF } from "./GeneratePDF";

function BulkPayoutStatus({
  bulkData,
  setBulkData,
  setProgress,
  setShowProgress,
}) {
  const [modalData, setModalData] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [disableButton, setDisableButton] = useState(false);
  let [checkedStatus, setCheckedStatus] = useState(0);
  const [orgName, setOrgName] = useState(false);
  const [orgOptions, setOrgOptions] = useState([]);
  const [selectedOrgName, setSelectedOrgName] = useState("All");

  const role = useSelector((store) => store.userReducer.role);
  const token = useSelector((store) => store.userReducer.token);

  useEffect(() => {
    const fetchOrganisations = async () => {
      try {
        if (role === "admin") return;
        const response = await getOrganisation(token);
        const orgData = response.data;
        setOrgOptions(orgData);
      } catch (err) {
        console.error("Error fetching organisations:", err.message);
        toast.error("Unable to fetch organisations.");
      }
    };

    fetchOrganisations();
  }, [token]);

  const viewData = (item, setModalData, setOpenModal) => {
    setModalData(item);
    setOpenModal(true);
  };

  const checkStatus = async (
    i,
    orderId,
    transactionId,
    setBulkData,
    bulkData
  ) => {
    const updatedBulkData = [...bulkData];

    updatedBulkData[i].statusLoading = true;
    setBulkData([...updatedBulkData]);

    const detail = {
      merchantRefNo: orderId,
      transactionId: transactionId,
    };

    const dataItem = await payoutStatus(detail);

    updatedBulkData[i].statusResponse = dataItem;
    updatedBulkData[i].statusChecked = true;
    updatedBulkData[i].statusLoading = false;

    setBulkData([...updatedBulkData]);
    // console.log("finalBulkData:::", updatedBulkData[i]);
  };

  const checkAllStatus = async (
    bulkData,
    setBulkData,
    setDisableButton,
    setProgress,
    setShowProgress,
    setCheckedStatus,
    checkedStatus
  ) => {
    setDisableButton(true);

    if (bulkData) {
      setShowProgress(true);
      let updatedCheckedStatus = checkedStatus;
      for (let i = 0; i < bulkData.length; i++) {
        const updatedBulkData = [...bulkData];
        updatedBulkData[i].statusLoading = true;
        setBulkData([...updatedBulkData]); // Force re-render


        const dataItem = {
          merchantRefNo: updatedBulkData[i].orderId,
          transactionId: updatedBulkData[i].transactionId,
        };

        const statusData = await payoutStatus(dataItem);
        updatedBulkData[i].statusResponse = statusData;
        updatedBulkData[i].statusChecked = true;
        updatedBulkData[i].statusLoading = false;

        setBulkData([...updatedBulkData]); // Force re-render

        updatedCheckedStatus += 1;
        setCheckedStatus(updatedCheckedStatus);
        setProgress((updatedCheckedStatus / bulkData.length) * 100);

        await new Promise((resolve) => setTimeout(resolve, 0)); // Allow state update to complete and UI to refresh
      }

      setShowProgress(false);
    }

    setDisableButton(false);
  };
  const filteredItems =
    bulkData?.filter((item) => {
      const matchesOrgName =
        selectedOrgName === "All" || !selectedOrgName
          ? true
          : item.orgName === selectedOrgName;

      return matchesOrgName;
    }) ?? [];

  const handleGeneratePDF = (item) => {
    generatePDF(item, token);
  };

  return (
    <div>
      <div className="table-main-report-2">
        <table className="table-user-management">
          <thead className="table-user-report-1">
            <tr>
              {(role == "super" ||
                role == "operation" ||
                role == "pros" ||
                role == "subSuper") && (
                <td className="filter-pos">
                  <div className="data-icon">
                    <p className="user-table-head-report">Org Name</p>
                    <FaFilter
                      style={{
                        marginRight: "0.2rem",
                        width: "1rem",
                        height: "1rem",
                        cursor: "pointer",
                      }}
                      onMouseEnter={() => setOrgName(true)}
                      onMouseLeave={() => setOrgName(false)}
                    />
                  </div>
                  {orgName && (
                    <div
                      className="transfer-mode"
                      onMouseEnter={() => setOrgName(true)}
                      onMouseLeave={() => setOrgName(false)}
                    >
                      <p
                        onClick={() => {
                          setSelectedOrgName("All");
                          setOrgName(false);
                        }}
                      >
                        All
                      </p>
                      {orgOptions.map((org) => (
                        <p
                          key={org.id}
                          onClick={() => {
                            setSelectedOrgName(org.orgName);
                            setOrgName(false);
                          }}
                        >
                          {org.orgName}
                        </p>
                      ))}
                      
                    </div>
                  )}
                </td>
              )}
              {(role == "super" ||
                role == "operation" ||
                role == "pros" ||
                role == "subSuper") && (
                <td>
                  <p className="user-table-head-report">PG Name</p>
                </td>
              )}
              <td className="filter-pos">
                <p className="user-table-head-report">Order Id</p>
              </td>
              <td>
                <p className="user-table-head-report">Transaction Mode</p>
              </td>
              <td>
                <p className="user-table-head-report">Type</p>
              </td>

              <td>
                <p className="user-table-head-report">Amount(₹)</p>
              </td>
              <td>
                <p className="user-table-head-report">Comm(₹)</p>
              </td>

              <td>
                <p className="user-table-head-report">Transaction Time</p>
              </td>
              <td>
                <p className="user-table-head-report">Updated Date</p>
              </td>
              <td>
                <p className="user-table-head-report">Status</p>
              </td>
              <td>
                <p className="user-table-head-report">View</p>
              </td>
              {role == "pros" && (
                <td>
                  <p className="user-table-head-report">Invoice</p>
                </td>
              )}
              <td>
                <p className="user-table-head-report">
                  <button
                    className={disableButton ? "disable-button" : "search-btn"}
                    onClick={() =>
                      disableButton == true
                        ? ""
                        : checkAllStatus(
                            bulkData,
                            setBulkData,
                            setDisableButton,
                            setProgress,
                            setShowProgress,
                            setCheckedStatus,
                            checkedStatus
                          )
                    }
                  >
                    Check All
                  </button>
                </p>
              </td>
            </tr>
          </thead>

          <tbody>
            {filteredItems &&
              filteredItems.length > 0 &&
              filteredItems.map((item, i) => {
                item.requestData = JSON.parse(item?.request);
                item.responseData = JSON.parse(item?.resposne);
                //   console.log("item:::::", item);s
                const dateString = item.createdAt;
                const date = new Date(dateString);
                const day = date.getDate();
                const month = date.getMonth() + 1;
                const year = date.getFullYear();
                const hours = date.getHours();
                const minutes = date.getMinutes();
                const seconds = date.getSeconds();
                const formattedDate = `${day}-${month}-${year}`;
                const formattedTime = `${hours}:${minutes}:${seconds}`;
                return (
                  <tr key={i} className="user-table-head-report">
                    {(role == "super" ||
                      role == "operation" ||
                      role == "pros" ||
                      role == "subSuper") && (
                      <td>
                        <p className="table-user-data-report order-break">
                          {(item && item.orgName) || "N/A"}
                        </p>
                      </td>
                    )}
                    {(role == "super" ||
                      role == "operation" ||
                      role == "pros" ||
                      role == "subSuper") && (
                      <td>
                        <p className="table-user-data-report order-break">
                          {(item && item.pg) || "N/A"}
                        </p>
                      </td>
                    )}
                    <td>
                      <p
                        className="table-user-data-report order-break"
                        style={{ width: "150px" }}
                      >
                        {item && item.orderId}
                      </p>
                    </td>
                    <td>
                      <p className="table-user-data-report order-break">
                        {item?.requestData.mode || "N/A"}
                      </p>
                    </td>
                    <td>
                      <p className="table-user-data-report type-data ">
                        {item && item.type ? item.type : ""}
                      </p>
                    </td>
                    <td>
                      <p className="table-user-data-report">
                        {item && item.requestData && item.requestData.amount}
                      </p>
                    </td>
                    <td>
                      <p className="table-user-data-report">
                        {item.responseStatus === "SETTLED"
                          ? item.totalComission
                          : 0}
                      </p>
                    </td>
                    <td>
                      <p className="table-user-data-report">
                        {formattedDate}-{formattedTime}
                      </p>
                    </td>
                    <td>
                      <p className="table-user-data-report">
                        {(() => {
                          const date = new Date(item.updatedAt);
                          const formattedDate = `${date.getDate()}-${
                            date.getMonth() + 1
                          }-${date.getFullYear()}`;
                          const formattedTime = `${date
                            .getHours()
                            .toString()
                            .padStart(2, "0")}:${date
                            .getMinutes()
                            .toString()
                            .padStart(2, "0")}:${date
                            .getSeconds()
                            .toString()
                            .padStart(2, "0")}`;
                          return `${formattedDate} ${formattedTime}`;
                        })()}
                      </p>
                    </td>
                    <td>
                      <p
                        className={
                          item && item.statusChecked == true
                            ? item &&
                              item.statusResponse &&
                              item.statusResponse.RESPONSE_STATUS ==
                                "SETTLEMENT_PROCESS"
                              ? "table-user-data-report process-color yel"
                              : item &&
                                  item.statusResponse &&
                                  item.statusResponse.RESPONSE_STATUS ==
                                    "SETTLEMENT_FAILED"
                                ? "table-user-data-report failed-color red"
                                : item &&
                                    item.statusResponse &&
                                    item.statusResponse.RESPONSE_STATUS ==
                                      "SETTLED"
                                  ? "success-color table-user-data-report green"
                                  : "table-user-data-report"
                            : "table-user-data-report"
                        }
                      >
                        {item.statusResponse.RESPONSE_STATUS == "SETTLED"
                          ? "SUCCESS"
                          : item.statusResponse.RESPONSE_STATUS ==
                              "SETTLEMENT_FAILED"
                            ? "FAILED"
                            : item.statusResponse.RESPONSE_STATUS ==
                                "SETTLEMENT_PROCESS"
                              ? "PROCESSING"
                              : item.responseData?.RESPONSE_STATUS == "SETTLED"
                                ? "SUCCESS"
                                : item.responseData?.RESPONSE_STATUS ==
                                    "SETTLEMENT_PROCESS"
                                  ? "PROCESSING"
                                  : item.responseData.RESPONSE_STATUS ==
                                      "SETTLEMENT_FAILED"
                                    ? "FAILED"
                                    : ""}
                      </p>
                    </td>

                    <td>
                      <button
                        className="view-btn-1"
                        onClick={() =>
                          viewData(item, setModalData, setOpenModal)
                        }
                      >
                        View
                      </button>
                    </td>

                    {role === "pros" && (
                      <td>
                        <button
                          className="generate-btn"
                          onClick={() => handleGeneratePDF(item)}
                        >
                          Generate
                        </button>
                      </td>
                    )}
                    <td>
                      <button
                        className={
                          disableButton == true
                            ? "disabled-button"
                            : "view-btn-1"
                        }
                        onClick={() =>
                          disableButton
                            ? ""
                            : checkStatus(
                                i,
                                item.orderId,
                                item.transactionId,
                                setBulkData,
                                bulkData
                              )
                        }
                      >
                        Check Status
                      </button>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
      {openModal && modalData && (
        <PayoutModal modalData={modalData} setOpenModal={setOpenModal} />
      )}
    </div>
  );
}

export default BulkPayoutStatus;
